import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type InstagramHandle from "./InstagramHandle";

@Model()
class InstagramPost extends ApplicationRecord {
  static jsonapiType = "instagram_posts";

  @Attr() body: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr() imageUrl: string;

  @BelongsTo() instagramHandle: InstagramHandle;

  @Attr() instagramHandleId: number;

  @Attr() publishedAt: string;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() url: string;

  @Attr() userName: string;

  @Attr() videoUrl: string;
}

export default InstagramPost;
